import React, { useEffect, useRef } from 'react';

interface Props {
  blok: {
    RecootyWidget: string; // keep as-is since this is what Storyblok uses
  };
}

const RecootyWidget: React.FC<Props> = ({ blok }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = blok.RecootyWidget;

    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://jobwidget.recooty.com/recooty-widget.js';

    script.onload = () => {
      if (window.RecootyWidget) {
        window.RecootyWidget.init('recooty-widget', {
          id: '6be091982acac47228ea0f1a53970b75',
          language: 'en',
        });
      } else {
        console.error('RecootyWidget not defined');
      }
    };

    document.body.appendChild(script);

    // ✅ Cleanup when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, [blok?.RecootyWidget]);

  return <div ref={containerRef} />;
};

export default RecootyWidget;
